import React from "react";
import { Navigate } from "react-router-dom";
import { routes } from "../helpers/constants";
import {
  authRoutes,
  mainRoutes,
  adminRoutes,
  invalidRoutes,
} from "./AllRoutes";
import { AdminLayout, AuthLayout, MainLayout } from "../layout";
import Page404 from "../pages/Page404";

const getRoutes = (user) => {
  const role = user ? user?.user_role : null;
  const loginRoute = localStorage.getItem("loginRoute");
  return [
    {
      path: routes.homepage,
      element: !user ? (
        <AuthLayout />
      ) : role === "ADMIN" ? (
        <Navigate to={routes.registration} />
      ) : (
        <Navigate to={routes.courses} />
      ),
      children: authRoutes,
    },
    {
      path: routes.homepage,
      element: user ? (
        role === "ADMIN" ? (
          <AdminLayout />
        ) : (
          <MainLayout />
        )
      ) : (
        <Navigate to={routes.login} />
      ),
      children: role === "ADMIN" ? adminRoutes : mainRoutes,
    },
    {
      path: "",
      element:
        !user && loginRoute ? (
          <Navigate to={loginRoute} />
        ) : role === "ADMIN" ? (
          <Navigate to={routes.registration} />
        ) : role === "ADMIN" ? (
          <Navigate to={routes.courses} />
        ) : (
          <Page404 />
        ),
      children: invalidRoutes,
    },
  ];
};

export default getRoutes;
